import axios from "axios";
import api from "src/configs/api";
import {
  CREATE_GNC_SIMULATOR,
  EDIT_GNC_SIMULATOR,
  GET_GNC_SIMULATOR,
  GNC_SIMULATOR_DETAIL,
  GET_GNC_SIMULATOR_OPTIONS,
  GET_GNC_SERIES_INPUT,
  GET_GNC_SERIES_DASHBOARD,
  GET_GNC_CASES_RESULT,
  GNC_SIMULATOR_DETAIL_6DOF,
  CREATE_GNC_SIMULATOR_6DOF,
  EDIT_GNC_SIMULATOR_6DOF,
  GET_GNC_SIMULATOR_6DOF,
  GET_GNC_SIMULATOR_6DOF_HISTORY,
  PAGE_INDEX_GNC_SIMULATOR_6DOF,
  GET_GNC_CASES_RESULT_6DOF,
} from "src/constant/endpoint";

const getSimulators = async (params) => await api.get(GET_GNC_SIMULATOR, { params }).then((response) => response?.data?.data);

const getSimulators6DOF = async (params) => await api.get(GET_GNC_SIMULATOR_6DOF, { params }).then((response) => response?.data?.data);

const getSimulators6DOFHistory = async (id) => await api.get(GET_GNC_SIMULATOR_6DOF_HISTORY(id)).then((response) => response?.data?.data);

const getSimulatorsDetail = async (id) => await api.get(GNC_SIMULATOR_DETAIL(id)).then((response) => response?.data?.data);

const getSimulatorsDetail6DOF = async (id) => await api.get(GNC_SIMULATOR_DETAIL_6DOF(id)).then((response) => response?.data?.data);

const createSimulator = ({ data }) => api.post(CREATE_GNC_SIMULATOR, { data }).then((response) => response?.data);

const createSimulator6DOF = ({ data }) => api.post(CREATE_GNC_SIMULATOR_6DOF, { data }).then((response) => response?.data);

const editSimulator = ({ data }) => api.put(EDIT_GNC_SIMULATOR(data.id), { data }).then((response) => response?.data);

const editSimulator6DOF = ({ data }) => api.put(EDIT_GNC_SIMULATOR_6DOF(data.id), { data }).then((response) => response?.data);

const getSimulatorOptions = async (type) => await api.get(GET_GNC_SIMULATOR_OPTIONS(type)).then((response) => response?.data?.data);

const getSeriesInput = async (id) => {
  return await api.get(GET_GNC_SERIES_INPUT(id)).then((response) => response?.data?.data);
};

const getContentFromLink = async (link) => axios.get(link);

const getDashboardLink = async (data) => {
  const { id, ...params } = data;
  return await api.post(GET_GNC_SERIES_DASHBOARD(id), { data: params });
};

const getPageIndexSimulator6DOF = async (id) => await api.get(PAGE_INDEX_GNC_SIMULATOR_6DOF(id)).then((response) => response?.data?.data);

const getCasesResult = async ({ id }) => await api.get(GET_GNC_CASES_RESULT(id)).then((response) => response?.data?.data);

const getCasesResult6DOF = async ({ id }) => await api.get(GET_GNC_CASES_RESULT_6DOF(id)).then((response) => response?.data?.data);

export {
  createSimulator,
  editSimulator,
  getSimulatorOptions,
  getSimulators,
  getSimulatorsDetail,
  getSeriesInput,
  getContentFromLink,
  getDashboardLink,
  getCasesResult,
  getSimulators6DOF,
  getSimulators6DOFHistory,
  createSimulator6DOF,
  getSimulatorsDetail6DOF,
  editSimulator6DOF,
  getPageIndexSimulator6DOF,
  getCasesResult6DOF,
};
